<script setup lang="ts">
  import { Dialog, Text, Button, IconLockedLarge } from "@ui-kit";

  const { isOpen } = defineProps<{ isOpen: boolean }>();
  const emit = defineEmits<{ "click:close": [value: void]; "click:block": [value: void] }>();
</script>

<template>
  <Dialog @close="emit('click:close')" :isOpen="isOpen" data-testid="card-item-block-dialog">
    <div class="block-item" data-testid="block-item-dialog">
      <div class="block-item__content">
        <IconLockedLarge />
        <div class="block-item__content-description">
          <Text font="body-bold-18">{{ $t("Заблокировать цветомодель") + "?" }}</Text>
          <Text font="body-regular-14">{{ $t("Товар перестанет автоматически пополняться") }}</Text>
        </div>
      </div>
      <div class="block-item__footer">
        <Button variant="negative" size="s" @click="emit('click:block')" data-testid="cart-item-block-dialog-block-btn">
          {{ $t("Заблокировать") }}
        </Button>
        <Button variant="secondary" size="s" @click="emit('click:close')" data-testid="cart-item-block-dialog-cancel-btn">
          {{ $t("Отменить") }}
        </Button>
      </div>
    </div>
  </Dialog>
</template>

<style scoped>
  .block-item {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 328px;
    padding: 24px 20px 20px;
  }

  .block-item__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .block-item__content-description {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .block-item__content-description > :deep(.text) {
    text-align: center;
  }

  .block-item__footer {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .block-item__footer :deep(.button) {
    width: 100%;
  }
</style>
